import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { JobStatus } from '../../types';

export default function StatusTitle({ status }: { status: JobStatus | undefined; }) {
    const keyPrefix = `status.${ status || 'all' }`;
    const { t } = useTranslation('myJobs', {  keyPrefix });

    return (
        <Root>
            <Typography variant="subtitle1">{ t('title') }</Typography>
            <Typography variant="caption"
                color="textSecondary"
            >{ t('description') }</Typography>
        </Root>
    );
}

const Root = styled(Box)(({ theme }) => ({
    paddingBottom: theme.spacing(3),
    lineHeight: 0
}));
